/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-02-02 19:59:06
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
global.__TRTC_DISABLE_PLUGINS__ = ["video-effect"];
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Easemob from "easemob-websdk";
import "./assets/font/iconfont.css";
import TableScrollSlider from "./components/scrollTab.vue";
// import { TUICallKit } from "@tencentcloud/call-uikit-vue2";
// Vue.prototype.$md5 = window.md5; // 或直接 md5
Vue.use(ElementUI);
// Vue.use(TRTC);
// Vue.use(TUICallKit);
Vue.component("TableScrollSlider", TableScrollSlider);
Vue.prototype.$easemob = Easemob;
Vue.use(quillEditor);
Vue.config.productionTip = false;
if (window.Vue) {
  console.warn("Vue 已存在，可能被污染");
}
// 全局api
import "./api/axios";
// 全局路由权限
import "./permission";
//全局数据格式化
import filter from "./filter";
import Plugins from "@/filter.js";
Vue.prototype.Plugins = Plugins;
Object.keys(filter).forEach((key) => Vue.filter(key, filter[key]));
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});
